import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { useQueryParams, encodeQueryParams } from 'use-query-params';
import { stringify } from 'query-string';

import { dashboardQueryTypes } from 'utils/query';
import { Svg } from 'components/Svg';

import s from './s.module.css';
import { limitDefault } from 'constant';

/**
 * @param {number} current
 * @param {number} last
 * @param {number} [delta=2]
 */
function pagination(current, last, delta = 2) {
  const left = current - delta;
  const right = current + delta + 1;
  const range = [];
  const rangeWithDots = [];
  let l;

  range.push(1);
  for (let i = current - delta; i <= current + delta; i++) {
    if (i >= left && i < right && i < last && i > 1) {
      range.push(i);
    }
  }
  range.push(last);

  range.forEach((i) => {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push(null);
      }
    }
    rangeWithDots.push(i);
    l = i;
  });

  return rangeWithDots;
}

export function Pagination({ total, paramName = 'offset' }) {
  const [query] = useQueryParams(dashboardQueryTypes);
  const skip = Number(query.offset) || 0;
  const take = Number(query.limit) || limitDefault;

  const currentPage = skip / take + 1;
  const pages = Math.ceil(total / take);
  const paginationList = pagination(currentPage, pages);

  if (pages <= 1) {
    return null;
  }

  const generateLinkUrl = (skip) => {
    const encodedQuery = encodeQueryParams(dashboardQueryTypes, {
      ...query,
      [paramName]: skip,
    });
    return (location) => {
      return `${location.pathname}?${stringify(encodedQuery)}`;
    };
  };

  return (
    <ol className={s.pagination}>
      <li>
        <NavLink
          to={generateLinkUrl(skip - take, paramName)}
          className={s.arrowLink}
          disabled={currentPage <= 1}
        >
          <Svg id="pagination-left" />
        </NavLink>
      </li>
      {paginationList.map((page, idx) => (
        <li key={idx}>
          <NavLink
            to={generateLinkUrl((page - 1) * take, paramName)}
            className={cn(s.pageLink, {
              [s.pageLinkActive]: currentPage === page,
            })}
            disabled={!page}
          >
            {page || '...'}
          </NavLink>
        </li>
      ))}
      <li>
        <NavLink
          to={generateLinkUrl(skip + take, paramName)}
          className={s.arrowLink}
          disabled={currentPage >= pages}
        >
          <Svg id="pagination-right" />
        </NavLink>
      </li>
    </ol>
  );
}
